import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react'
import { ThemeProvider } from 'styled-components'
import { Helmet } from 'react-helmet'
import theme from '@styles/theme'
import GlobalStyle from '@styles/global'
import Fav from '@icons/favicon.ico'
import '@styles/videoPlayer.css'

const RootWrap: React.FC = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>Корпоративная пенсионная программа для малого бизнеса</title>
        <link data-n-head="1" rel="icon" type="image/x-icon" href={Fav}></link>
        <meta name="description" content="Умный социальный пакет для вашей команды от Сбер НПФ" />
        <meta property="og:description" content="Умный социальный пакет для вашей команды от Сбер НПФ" />
        <script>{'history.scrollRestoration = "manual"'}</script>
        {/* <meta property="og:title" content="Какую пенсию вы заработали уже сейчас?" />
        <meta property="og:image:secure_url" content="https://www.npfsberbanka.ru/upload/mail/penshowcase.png" />
        <meta name="yandex-verification" content="9ee4f9eea36d314f" />
        <meta property="og:url" content="https://www.npfsberbanka.ru/lp/whereismypension/ " />
        <meta property="og:image:url" content="https://www.npfsberbanka.ru/upload/mail/penshowcase.png" />
        <meta property="og:site_name" content="СберНПФ" />
        <meta property="og:locale" content="ru_RU" />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="какая пенсия, какая пенсия 2021, в каком году на пенсию, какая должна быть пенсия, минимальная пенсия, пенсионный стаж, какая пенсия в россии, деньги пенсия, пенсионный коэффициент, пенсия накопление, пенсионные программы, пенсия доход, обязательное пенсионное страхование, пенсионные баллы, страховая пенсия, накопительная пенсия, индивидуальный пенсионный план, корпоративная пенсионная программа, пенсия для сотрудников, НПФ Сбербанка, СберНПФ, заключить договор, пенсионный план, пенсионная программа, пенсионная витрина, опс, ипп, кпп, сбербанк онлайн"
        /> */}
        <script>
          {`(function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
            var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-TQX7VQ');`}
        </script>
        <script>
          {`(function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(), event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-59DPBH');`}
        </script>

        <script>
          {`(function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
            var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-TLLMLP');`}
        </script>

        <script type="text/javascript">
          {` (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(20662768, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true,
            webvisor:true
        });`}
        </script>
        <noscript>
          {`
            <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-59DPBH" height="0" width="0" style="display:none;visibility:hidden"></iframe>
            </noscript>
            <noscript>
                <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TQX7VQ" height="0" width="0" style="display:none;visibility:hidden"></iframe>
            </noscript><noscript>
                <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TLLMLP" height="0" width="0" style="display:none;visibility:hidden"></iframe>
            </noscript>
            <!-- Yandex.Metrika counter -->
                    <noscript><div><img src="https://mc.yandex.ru/watch/20662768" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
            `}
        </noscript>
      </Helmet>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}

export default RootWrap
